import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LicensePlanBreadcrumbComponent} from '@go-modules/components/breadcrumbs/folder-breadcrumbs/license-plan-breadcrumb/license-plan-breadcrumb.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { LicensePlanBadgeModule } from '@go-modules/components/license-plan-badge/license-plan-badge.module';
import { GoMaterialModule } from '@go-modules/go-material.module';

@NgModule({
	imports: [
		CommonModule,
		GoMaterialModule,
		TranslateModule,
		LicensePlanBadgeModule
	],
	declarations: [
		LicensePlanBreadcrumbComponent
	],
	exports: [
		LicensePlanBreadcrumbComponent
	],
	providers: [
		TranslatePipe
	]
})
export class LicensePlanBreadcrumbModule {}
